(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("evaluatorSettings", {
        templateUrl: "app/settings/theme/evaluator/evaluatorSettings.component.html",
        controller: ["frameworkService", "tenantResource", "tenantFeaturesResource", "messageService", "$timeout", EvaluatorSettingsCtrl],
        controllerAs: "vm"
    });
    function EvaluatorSettingsCtrl(frameworkService, tenantResource, tenantFeaturesResource, messageService, $timeout) {
        var vm = this;
        vm.frameworkData = frameworkService.data;
        vm.hideEvaluatorId = vm.frameworkData.tenant.tenantFeaturesHideEvaluatorId;
        vm.saving = false;
        //
        vm.onChange = onChange;
        //////////////////////////////////////////////////////////////////////////
        function onChange(newValue) {
            if (vm.saving)
                return;
            vm.saving = true;
            vm.hideEvaluatorId = newValue;
            $timeout(function () {
                update();
            }, 300);
        }
        function update() {
            tenantFeaturesResource.updateHideEvaluatorId({ value: vm.hideEvaluatorId }, function (result) {
                if (result.value) {
                    tenantResource.removeSettingsFromCache();
                    messageService.success("common.changesSaved");
                    vm.frameworkData.tenant.tenantFeaturesHideEvaluatorId = vm.hideEvaluatorId;
                }
                else {
                    messageService.error("common.genericError");
                }
                vm.saving = false;
            }, function (error) {
                messageService.error(error);
                vm.saving = false;
            });
        }
    }
})();
